namespace GeniuzPOS.Inventory {
    export namespace IcStockSoldDtService {
        export const baseUrl = 'Inventory/IcStockSoldDt';

        export declare function Create(request: Serenity.SaveRequest<IcStockSoldDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockSoldDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockSoldDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockSoldDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockSoldDt/Create",
            Update = "Inventory/IcStockSoldDt/Update",
            Delete = "Inventory/IcStockSoldDt/Delete",
            Retrieve = "Inventory/IcStockSoldDt/Retrieve",
            List = "Inventory/IcStockSoldDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockSoldDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
